/* eslint-disable no-unsafe-optional-chaining */
import React, { useContext } from 'react';

import CommonSidebar from '@totem/components/common/sidebar/Sidebar';
import SideBarNotes from '@totem/components/media/notes/SideBarNotes';
import BuildingContext from '@totem/components/portfolio/buildings/details/container/BuildingContext';
import Contacts from '@totem/components/portfolio/buildings/details/container/Contacts';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';

import BuildingInfo from './BuildingInfo';

import './sidebar.css';

const Sidebar = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data: building } = useContext(BuildingContext);

  const {
    buildingContact: showBuildingContact,
    buildingNote: showBuildingNote,
  } = userProfile.organization?.preferences?.features;

  return (
    <CommonSidebar tabLabel="Details">
      <div styleName="sidebar-content">
        <BuildingInfo />
        {showBuildingContact && <Contacts />}
        {showBuildingNote &&
          isNotNull(building) &&
          isNotNull(building.building) && (
            <SideBarNotes
              title="Building Notes"
              noContentMessage="Attach a note to your building to keep track if site specific information."
              subjectId={building.building.id}
            />
          )}
      </div>
    </CommonSidebar>
  );
};

export default Sidebar;
